import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ClearBacModalComponent } from '@app/library/components/modals/clear-bac-modal/clear-bac-modal.component';
import { DeleteBacModalComponent } from '@app/library/components/modals/delete-bac-modal/delete-bac-modal.component';
import { Logger } from '@radioking/shared/logger';

import { Bac, RootBac } from '../../../models/bac.model';

const log = new Logger('sbac root');

@Component({
  selector: 'rk-library-sbac',
  templateUrl: './library-sbac.component.html',
  styleUrls: ['./library-sbac.component.scss'],
})
export class LibrarySbacComponent {
  @Input()
  bacs: RootBac[];

  constructor(private readonly dialog: MatDialog) {}

  deleteBac(bac: Bac) {
    const dialogRef = this.dialog.open(DeleteBacModalComponent, {
      data: bac,
    });

    dialogRef.afterClosed().subscribe(res => log.debug(`Result close : ${res}`));
  }

  clearBac(bac: Bac) {
    const dialogRef = this.dialog.open(ClearBacModalComponent, {
      data: bac,
    });

    dialogRef.afterClosed().subscribe(res => log.debug(`Result close : ${res}`));
  }
}
